import { lazy, Suspense } from "react";
import EnterViewportAnimation from "../EnterViewportAnimation";
import PlayOnEnterViewport from "../LottieAnimation/PlayOnEnterViewport";
import Icon from "../Icon";
import { Spinner } from "reactstrap";
import { useLottieAnimation } from "../../hooks/CmsHooks";
import { cmsAssetUrl } from "../../utils/CmsUtils";

const LottieAnimation = lazy(() => import("../LottieAnimation"));

const InnerCockpitAnimation = ({ id, width, height }) => {
  const key = `animation-${id}`;
  const animation = useLottieAnimation(id);
  const loop = animation?.loop || false;
  return animation?.file?.path ? (
    loop ? (
      <EnterViewportAnimation>
        <LottieAnimation
          path={cmsAssetUrl(animation.file.path)}
          loop={loop}
          autoplay={loop}
          width={width}
          height={height}
        />
      </EnterViewportAnimation>
    ) : (
      <PlayOnEnterViewport
        key={key}
        path={cmsAssetUrl(animation.file.path)}
        width={width}
        height={height}
      />
    )
  ) : (
    <div
      className="empty-msg"
      style={{
        display: "block",
        height: "200px",
        width: "100%",
        background: "#ccc"
      }}
    >
      <div>
        <Icon name="face-sad-tear" size="4x" />
      </div>
      <div>No animation found</div>
    </div>
  );
};

const CockpitAnimation = ({ id, width, height }) => {
  return (
    <Suspense fallback={<Spinner />}>
      <InnerCockpitAnimation id={id} width={width} height={height} />
    </Suspense>
  );
};

export default CockpitAnimation;
